import {Observable, OperatorFunction} from 'rxjs'
import {mergeMap, pairwise, startWith} from 'rxjs/operators'

export function distinctUntilChangedWithKeys<T extends Record<string, any>>(startValue?: T): OperatorFunction<T, { value: T | undefined; changedKeys: string[] }> {
	return (source: Observable<T>) => {
		return source.pipe(
			startWith(startValue),
			pairwise(),
			mergeMap(([prev, curr]) => {
				let singleChange: T | undefined = undefined
				if (!curr && prev) singleChange = prev
				else if (curr && !prev) singleChange = curr

				if (singleChange) {
					// First emission - all keys are "changed"
					return [{
						value: curr,
						changedKeys: Object.keys(singleChange),
					}]
				}

				if (!curr || !prev) return []

				const changedKeys: string[] = [];
				const allKeys = new Set([...Object.keys(prev), ...Object.keys(curr)]);

				for (const key of allKeys) {
					if (prev[key] !== curr[key]) {
						changedKeys.push(key);
					}
				}

				if (changedKeys.length === 0) return []

				return [{
					value: curr,
					changedKeys,
				}]
			}),
		);
	};
}